var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/prefer-default-export */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MarketingSettingsCacheKey } from '../config';
import mutationFnFactory from './mutationFnFactory';
export function useMarketingSettingsMutation(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.mutationOptions, mutationOptions = _b === void 0 ? {} : _b;
    var queryClient = useQueryClient();
    return useMutation(__assign({ mutationKey: MarketingSettingsCacheKey(keyProps), mutationFn: mutationFnFactory(config, keyProps), onSuccess: function () {
            return queryClient.invalidateQueries(MarketingSettingsCacheKey(keyProps));
        } }, mutationOptions));
}
